import type { SimulationConfig } from './schema';
import { generateTiling } from './corners';

export const DEFAULT_CONFIG: SimulationConfig = {
  system: 'rigid',
  vizMode: 'distance',
  resolution: 512,
  chunkSize: 512,
  phaseSpace: {
    x: { dimension: 'angle1', min: -Math.PI, max: Math.PI },
    y: { dimension: 'angle2', min: -Math.PI, max: Math.PI },
    initialValues: {
      angle1: 0,
      velocity1: 0,
      angle2: 0,
      velocity2: 0,
      stretch1: 0,
      stretchRate1: 0,
      stretch2: 0,
      stretchRate2: 0,
    },
    mode: 'manual',
    tiling: generateTiling('rigid', 3, 2, 2, [0, 0, 0, 0, 0, 0, 0, 0]),
  },
  dt: 0.002,
  iterationsPerFrame: 10,
  maxIter: 5000,
  perturb: 0.00001,
  perturbDistribution: 'uniform',
  trials: 1,
  neighborCount: 8,
  m1: 1,
  m2: 1,
  L1: 1,
  L2: 1,
  k1: 50,
  k2: 50,
  sculptureWeight: 1000,
  sculptureRod: 50,
  sculptureAxle: 10,
  sculptureReduction: 0.1,
  sculptureN: 3,
  rpM0: 1000,
  rpM1: 100,
  rpL0: 50,
  rpL1: 10,
  rpA0: 10,
  colormap: 6,
  toneMapping: 0,
  seed: 42,
  iterationsBeforeSnapshot: 1000,
  iterationsAfterSnapshot: 500,
  minimumImprovementToUpdate: 0,
};
